import Gateway from "./Gateway";
import Notify from "./Notify";
import DFModel from "./DFModel";
import ScreenHelper from "./ScreenHelper";
import BevStatHelper from "./BevStatHelper";

export default class Facade{

  static GOTO_DOWNLOAD_URL = "https://partner.volcengine.com/partners/auth/confirm?inviteToken=1H4J38UGHZI4OF0Q2KLLARYE73STCX5Z2R20MU3MHAGT69REGY9RP3LU7A1B15PZ&partnerType=101&partnerName=%E4%B8%8A%E6%B5%B7%E8%BF%9E%E6%82%A6%E7%BD%91%E7%BB%9C%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&identityType=10";

  static listenersMap = new Map();

  /**
   * 发送通告
   * @param data 数据
   * @param name 通告类型名
   */
  static sendNotify(name, sender, data)
  {
    var notify = new Notify(name, sender, data);

    if (Facade.listenersMap.has(name))
    {
      let arr = Facade.listenersMap.get(name);
      arr.forEach((handler) =>
      {
        handler(notify);
      });
    }
  }

  /**
   * 注册对通告的监听.
   * 当触发时将回调handler(Notify)
   */
  static regListener(notifyName, handler)
  {
    if (!Facade.listenersMap.has(notifyName))
    {
      Facade.listenersMap.set(notifyName, []);
    }
    Facade.listenersMap.get(notifyName).push(handler);
  }

  /**
   * 移除监听.
   * @param notifyName
   * @param handler
   */
  static removeListener(notifyName, handler)
  {
    if (Facade.listenersMap.has(notifyName))
    {
      let arr = Facade.listenersMap.get(notifyName);
      let index = arr.indexOf(handler);
      if (index != -1)
        arr.splice(index, 1);
    }
  }




  static gw = new Gateway();
  static model = new DFModel();
  static screenHelper = new ScreenHelper();
  static bevStatHelper = new BevStatHelper();



}
